import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";


export default class TransitionClients extends AbstractView {


	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}

	initDOM() {
		this.$images = this.$wrapper.find('.agence-clients_image-wrapper');
	}

	initEl() {
		this.tw.stshow = ScrollTrigger.create({
			trigger: this.$wrapper,
			start: 'top 80%',
			onEnter: () => this.animateFromTop()
		});
		this.tw.sthide = ScrollTrigger.create({
			trigger: this.$wrapper,
			start: 'top bottom',
			onLeaveBack: () => this.hideElements()
		});
		this.hideElements();
	}

	animateFromTop() {
		gsap.fromTo(this.$images, {
			autoAlpha: 0,
			y: 50,
		}, {
			duration: 0.5,
			autoAlpha: 1,
			y: 0,
			stagger: 0.03,
			immediateRender: true
		});
	}

	hideElements() {
		gsap.set(this.$images, {autoAlpha: 0});
	}
}
